import { useEffect } from 'react';

const useScrollToSelectedValue = ({ menuRef, selectedValue }) => {
  useEffect(() => {
    menuRef.current.scrollTop = menuRef.current.querySelector(`[data-attr='${selectedValue}']`)?.offsetTop;
  }, [menuRef, selectedValue]);
};

export default useScrollToSelectedValue;
